import { Button, Separator } from '@monksflow/monks-ui';
import type { ExternalToolCategoryDto } from '@/entities/external-tool';
import { useTranslation } from 'react-i18next';

export interface ExternalToolsFilterProps {
  title: string;
  categories: ExternalToolCategoryDto[];
  selectedCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

export function ExternalToolsFilter({
  title,
  categories,
  selectedCategory,
  onCategoryChange,
}: ExternalToolsFilterProps) {
  const { t } = useTranslation('admin');

  return (
    <>
      <div className="flex w-full flex-col gap-3">
        <h2 className="w-full text-heading-xl text-foreground">{title}</h2>
        <div className="mt-4 flex w-full flex-wrap items-center gap-2">
          <Button
            variant={selectedCategory ? 'outline' : 'default'}
            aria-pressed={!selectedCategory}
            onClick={() => onCategoryChange(null)}
            data-testid="filter-all"
          >
            {t('externalToolsWidget.externalToolsFilter.all')}
          </Button>
          {categories.map(
            (category) =>
              category.isVisible && (
                <Button
                  key={category.id}
                  variant={selectedCategory === category.id ? 'default' : 'outline'}
                  aria-pressed={selectedCategory === category.id}
                  onClick={() => onCategoryChange(category.id)}
                  data-testid={`filter-${category.id}`}
                >
                  {category.title}
                </Button>
              ),
          )}
        </div>
      </div>
      <Separator />
    </>
  );
}
